export default function ({ store, $storage }) {
  let session = $storage.getUniversal('guest-session-id')
  if (session === undefined || session === null) {
    session = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    $storage.setUniversal('guest-session-id', session)
  }
  if (session) {
    store.dispatch('orders/fetchCart', { session })
  }
}
